import { TITLE_OPTS } from "@typings/globals";

import { SelectOption } from "@ui/Atoms/Form/SelectExtended";

import { capitalize } from "@services/Capitalize";

import { TranslateFunction } from "@hooks/useTranslate";

const getTitleOptions = (translate: TranslateFunction): SelectOption[] => [
  { value: TITLE_OPTS.MR, label: capitalize(translate("mr")) },
  { value: TITLE_OPTS.MS, label: capitalize(translate("ms")) },
];

export { getTitleOptions };
